import {Nomenclature} from './Nomenclature';
import {FrxBaseBean} from './frxbasebean';
export class Income extends FrxBaseBean {
	lawsuiteId: number;
	amount: number;
	note: string;
	incomeGround: Nomenclature;

}
